<template>
  <div class="mod-production-cost-card">
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="工单号"><el-input v-model="q.productionOrderCode" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="物料编码"><el-input v-model="q.materialCode" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="q.orderStatus" size="small" clearable style="width:120px">
          <el-option label="已下达" value="1" /><el-option label="已完工" value="3" /><el-option label="已关闭" value="4" />
        </el-select>
      </el-form-item>
      <el-form-item><el-button v-if="isAuth('production:productionCostCard:list')" type="primary" size="small" @click="search">查询</el-button></el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="productionOrderCode" label="工单号" min-width="130" header-align="center" align="left">
        <template slot-scope="s"><el-link type="primary" @click="openDetail(s.row)">{{ s.row.productionOrderCode }}</el-link></template>
      </el-table-column>
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="quantity" label="计划量" width="90" header-align="center" align="left" />
      <el-table-column label="材料" width="100" header-align="center" align="right">
        <template slot-scope="s">{{ money(s.row._card && s.row._card.materialCost) }}</template>
      </el-table-column>
      <el-table-column label="人工" width="100" header-align="center" align="right">
        <template slot-scope="s">{{ money(s.row._card && s.row._card.laborCost) }}</template>
      </el-table-column>
      <el-table-column label="委外" width="100" header-align="center" align="right">
        <template slot-scope="s">{{ money(s.row._card && s.row._card.subcontractCost) }}</template>
      </el-table-column>
      <el-table-column label="制造费用" width="100" header-align="center" align="right">
        <template slot-scope="s">{{ money(s.row._card && s.row._card.overheadCost) }}</template>
      </el-table-column>
      <el-table-column label="合计" width="110" header-align="center" align="right">
        <template slot-scope="s">{{ money(s.row._card && s.row._card.totalCost) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="list-pagination"
      background
      :current-page="pageIndex"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="p => { pageIndex = p; load() }"
    />

    <el-dialog title="工单成本卡" :visible.sync="detailVisible" width="960px" append-to-body>
      <div v-loading="detailLoading">
        <el-descriptions v-if="card" :column="3" border size="small" style="margin-bottom:16px">
          <el-descriptions-item label="工单号">{{ card.productionOrderCode || detail.productionOrderCode }}</el-descriptions-item>
          <el-descriptions-item label="成品">{{ card.materialCode || detail.materialCode }} {{ card.materialName || detail.materialName }}</el-descriptions-item>
          <el-descriptions-item label="计划/已入库">{{ fmtQty(card.planQty != null ? card.planQty : detail.quantity) }} / {{ fmtQty(card.receivedQty) }}</el-descriptions-item>
          <el-descriptions-item label="材料成本">{{ money(card.materialCost) }}</el-descriptions-item>
          <el-descriptions-item label="人工成本">{{ money(card.laborCost) }}</el-descriptions-item>
          <el-descriptions-item label="委外成本">{{ money(card.subcontractCost) }}</el-descriptions-item>
          <el-descriptions-item label="制造费用">{{ money(card.overheadCost) }}</el-descriptions-item>
          <el-descriptions-item label="成本合计">{{ money(card.totalCost) }}</el-descriptions-item>
          <el-descriptions-item label="在制材料">{{ money(card.wipMaterialCost) }}</el-descriptions-item>
          <el-descriptions-item label="已结转材料">{{ money(card.transferredMaterialCost) }}</el-descriptions-item>
          <el-descriptions-item label="已入库成本">{{ money(card.transferredTotalCost) }}</el-descriptions-item>
          <el-descriptions-item label="平均单位成本">{{ money(card.avgUnitCost) }}</el-descriptions-item>
        </el-descriptions>
        <el-tabs v-if="card">
          <el-tab-pane label="报工人工" name="labor">
            <div v-if="card.laborLines && card.laborLines.length" class="cost-panel-hint">人工成本汇总仅计入已审报工；未审行仅供参考。</div>
            <el-table :data="card.laborLines || []" border empty-text="暂无报工记录" :header-cell-style="headStyle">
              <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
              <el-table-column prop="reportCode" label="报工单号" min-width="120" header-align="center" align="left" />
              <el-table-column prop="reportDate" label="日期" width="110" header-align="center" align="left">
                <template slot-scope="s">{{ formatDate(s.row.reportDate) }}</template>
              </el-table-column>
              <el-table-column prop="processCode" label="工序" width="100" header-align="center" align="left" />
              <el-table-column prop="processName" label="工序名称" min-width="120" header-align="center" align="left" />
              <el-table-column prop="reportQty" label="报工数量" width="100" header-align="center" align="left">
                <template slot-scope="s">{{ fmtQty(s.row.reportQty) }}</template>
              </el-table-column>
              <el-table-column prop="scrapQty" label="报废数量" width="100" header-align="center" align="left">
                <template slot-scope="s">{{ fmtQty(s.row.scrapQty) }}</template>
              </el-table-column>
              <el-table-column prop="laborHours" label="工时" width="90" header-align="center" align="left">
                <template slot-scope="s">{{ fmtQty(s.row.laborHours) }}</template>
              </el-table-column>
              <el-table-column prop="laborRate" label="费率" width="90" header-align="center" align="left">
                <template slot-scope="s">{{ fmtQty(s.row.laborRate) }}</template>
              </el-table-column>
              <el-table-column prop="laborAmount" label="金额" width="100" header-align="center" align="left">
                <template slot-scope="s">{{ money(s.row.laborAmount) }}</template>
              </el-table-column>
              <el-table-column prop="approveStatus" label="状态" width="80" header-align="center" align="center" fixed="right">
                <template slot-scope="s">
                  <el-tag :type="String(s.row.approveStatus) === '2' ? 'success' : 'info'" size="small">
                    {{ String(s.row.approveStatus) === '2' ? '已审' : '未审' }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="成品入库" name="receipt">
            <el-table :data="card.receiptLines || []" border empty-text="暂无已审入库" :header-cell-style="headStyle">
              <el-table-column prop="receiptSource" label="来源" width="100" header-align="center" align="left" />
              <el-table-column prop="receiptCode" label="单号" min-width="120" header-align="center" align="left" />
              <el-table-column prop="receiptDate" label="日期" width="110" header-align="center" align="left">
                <template slot-scope="s">{{ formatDate(s.row.receiptDate) }}</template>
              </el-table-column>
              <el-table-column prop="quantity" label="数量" width="90" header-align="center" align="left">
                <template slot-scope="s">{{ fmtQty(s.row.quantity) }}</template>
              </el-table-column>
              <el-table-column prop="unitCost" label="单位成本" width="110" header-align="center" align="left">
                <template slot-scope="s">{{ money(s.row.unitCost) }}</template>
              </el-table-column>
              <el-table-column prop="lineCost" label="行成本" width="100" header-align="center" align="left">
                <template slot-scope="s">{{ money(s.row.lineCost) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import { listProductionOrder } from '../../api/production/productionOrder'

export default {
  name: 'ProductionCostCard',
  data() {
    return {
      q: { productionOrderCode: '', materialCode: '', orderStatus: '' },
      list: [], loading: false, pageIndex: 1, pageSize: 20, total: 0, permCodes: [],
      detailVisible: false, detailLoading: false, detail: {}, card: null,
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    search() { this.pageIndex = 1; this.load() },
    money(v) {
      if (v == null || v === '') return '—'
      const n = Number(v)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    fmtQty(v) {
      if (v == null || v === '') return '0.00'
      const n = Number(v)
      if (Number.isNaN(n)) return '0.00'
      return n.toFixed(2)
    },
    formatDate(v) {
      if (!v) return '—'
      const s = String(v)
      if (s.length >= 10) return s.slice(0, 10)
      const d = new Date(v)
      if (Number.isNaN(d.getTime())) return '—'
      const p = n => String(n).padStart(2, '0')
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
    },
    load() {
      this.loading = true
      const status = this.q.orderStatus || ''
      listProductionOrder({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        productionOrderCode: this.q.productionOrderCode || '',
        materialCode: this.q.materialCode || '',
        orderStatus: status
      }).then(res => {
        const body = res.data || {}
        const rows = body.list || []
        this.list = rows
        this.total = body.total != null ? Number(body.total) : rows.length
        const ids = rows.filter(row => String(row.orderStatus) !== '0').map(row => row.productionOrderId).filter(Boolean)
        if (!ids.length) return
        request.post('/production/costCards', { ids }).then(r => {
          const byId = {}
          ;(r.data || []).forEach(card => { byId[card.productionOrderId] = card })
          rows.forEach(row => {
            if (byId[row.productionOrderId]) this.$set(row, '_card', byId[row.productionOrderId])
          })
        }).catch(() => {})
      }).catch(() => { this.list = []; this.total = 0 }).finally(() => { this.loading = false })
    },
    openDetail(row) {
      this.detail = row
      this.card = row._card || null
      this.detailVisible = true
      this.detailLoading = true
      request.get('/production/costCard', { params: { id: row.productionOrderId } }).then(res => {
        this.card = res.data || {}
        this.$set(row, '_card', this.card)
      }).catch(() => { this.card = this.card || {} }).finally(() => { this.detailLoading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.cost-panel-hint { margin-bottom: 8px; font-size: 13px; color: #909399; }
</style>
